
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wireline-construction",
      function () {
        return require("private-next-pages/wireline-construction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wireline-construction"])
      });
    }
  